module.exports = __webpack_public_path__ + "img/honor_11.6061ec3b.png";